import { useEffect } from 'react';

const FOCUS_KEYS = new Set(['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Enter']);

function focusableElements(): HTMLElement[] {
  return Array.from(document.querySelectorAll<HTMLElement>('.focusable')).filter(
    (el) => !(el as HTMLButtonElement).disabled,
  );
}

function handleKeyDown(event: KeyboardEvent): void {
  const { key } = event;
  if (!FOCUS_KEYS.has(key)) return;

  // While the player is typing into the Type chip's text field, arrow keys
  // and Enter belong to the input (cursor movement, submitting the reply),
  // not to chip navigation. ChipRow handles Enter/Escape on the input itself
  // and stops those from bubbling here; this guard covers the arrow keys,
  // which it never sees.
  const active = document.activeElement;
  if (active instanceof HTMLInputElement || active instanceof HTMLTextAreaElement) return;

  event.preventDefault();

  if (key === 'Enter') {
    const active = document.activeElement;
    if (active instanceof HTMLElement && active.classList.contains('focusable')) {
      active.click();
    }
    return;
  }

  const elements = focusableElements();
  if (elements.length === 0) return;

  const currentIndex = elements.indexOf(document.activeElement as HTMLElement);
  const forward = key === 'ArrowRight' || key === 'ArrowDown';
  let nextIndex: number;

  if (currentIndex === -1) {
    nextIndex = 0;
  } else if (forward) {
    nextIndex = (currentIndex + 1) % elements.length;
  } else {
    nextIndex = (currentIndex - 1 + elements.length) % elements.length;
  }

  elements[nextIndex].focus();
}

export default function useDpad(): void {
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
}
